import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { AnimacoesComponent } from './components/animacoes/animacoes.component';
import { MateriaisComponent } from './components/materiais/materiais.component';
import { ContatoComponent } from './components/contato/contato.component';
import { EntrevistaComponent } from './components/entrevista/entrevista.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        AnimacoesComponent,
        MateriaisComponent,
        ContatoComponent,
        EntrevistaComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule.forRoot()
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}
